<template>
    <ul class="sector-post__files" v-if="files">
        <li v-for="file in files">
            <button type="button" @click="handleFileDownload(file.uuid, file.filename)" class="download">
                <Spinner :height="13" :width="13" v-if="$wait.is(`downloading-file-${file.uuid}`)"/>
                <SvgIcon icon="download" class="download__icon" v-else/>
                <span class="download__title" v-text="file.filename"/>
                <span class="download__mime sector" v-if="file.filetype">
                    {{ formattedFileType(file.filetype) }}
                </span>
            </button>
        </li>
    </ul>
</template>
<script>
import SvgIcon from '@components/SvgIcon.vue';
import Spinner from '@components/Spinner.vue';
import API from '@api';

export default {
    name: 'SectorPostCardFiles',
    components: {
        Spinner,
        SvgIcon,
    },
    props: {
        files: {
            type: Array,
            default: [],
        }
    },
    methods: {
        handleFileDownload: async function(uuid, filename) {
            try {
                this.$wait.start(`downloading-file-${ uuid }`);
                await API.downloadAttachment(uuid, filename);
            } catch(err) {
                console.warn()
            } finally {
                this.$wait.end(`downloading-file-${ uuid }`);
            }
        },
        formattedFileType(filetype){
            const mimetype = filetype.split('/')[1];

            switch(mimetype) {
                case "vnd.oasis.opendocument.presentation":
                    return "odp";
                case "vnd.oasis.opendocument.spreadsheet":
                    return "ods";
                case "vnd.oasis.opendocument.text":
                    return "odt";
                case "vnd.openxmlformats-officedocument.presentationml.presentation":
                    return "pptx";
                case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return "xlsx";
                case "vnd.openxmlformats-officedocument.wordprocessingml.document":
                    return "docx";
                case "xhtml+xml":
                    return "xhtml";
                case "vnd.amazon.ebook":
                    return "azw";
                case "vnd.ms-excel":
                    return "xls";
                default:
                    return mimetype;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.download {
    appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    column-gap: 1.4rem;
    border: .1rem solid $border;
    border-radius: .4rem;
    padding: 1.8rem 1.6rem;
    width: 100%;
    cursor: pointer;

    .download__icon {
        height: 1.3rem;
        width: 1.3rem;
        margin-right: 0;
        flex: 0 0 1.3rem;
        stroke: $accent;
    }

    .download__title {
        font-family: Axiforma, sans-serif;
        font-size: 1.2rem;
        line-height: 1.4rem;
        flex: 1 1 auto;
        color: $accent;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
    }

    .download__mime {
        margin: 0;
        flex: 0 0 5.6rem;
        text-align: center;
    }
}

.sector-post__files {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    margin: 0;
    width: 100%;

    li {
        width: 100%;
    }
}
</style>
